import { HandleFormSubmit } from "../../types";
import { MutationFunction } from "../../../../queries/quote/components/FormSubmitMutation";
import { EventInterfaces } from "@comparaonline/event-tracker";
import { IAttribution } from "../../../../lib/attributionContext/types";
import { ISocketEmitFns } from "../../../common/context/quoteFormConnector/types";
import { sendFormSubmitEvent } from "../../../common/eventTracker/events";
import { responseSaveFormQuote } from "./responseSaveFormQuote";
import { goToResults } from "./goToResults";

interface HandleSubmitParams {
  submitMutationFn: MutationFunction;
  formId: string;
  formType: EventInterfaces.FormTypes;
  sendFormSubmitEvent: ReturnType<typeof sendFormSubmitEvent>;
  attribution: IAttribution;
  saveQuoteForm: ISocketEmitFns["saveQuoteForm"];
  businessCode: string;
}

type HandleSubmit = (params: HandleSubmitParams) => HandleFormSubmit;

export const handleSubmit: HandleSubmit = ({
  submitMutationFn,
  formId,
  formType,
  sendFormSubmitEvent,
  attribution,
  saveQuoteForm,
  businessCode
}) => values => {
  const saveFormByMutation = businessCode === "car-insurance-cl";
  sendFormSubmitEvent(formId, values, "SUCCESS", formType);

  const data: Record<string, any> = { ...values, attribution, id: formId };
  return saveFormByMutation
    ? submitMutationFn(data).then(goToResults)
    : saveQuoteForm(data, responseSaveFormQuote);
};
